export class Assessment {
    ID: number;
    Title: string;
    Category: string;
    InteractionCode: string;
    ActivityID: string;
}

export class StudentAssessmentDetails {
    ID: number;
    AssessmentID: number;
    StudentID: number;
    StudentName: string;
    NumAttempts: number;
    DateRequested: Date;
    StartedActivityID: string;
    Score: number;
    Passed: boolean;
    ResultsJson: string;
    CompletedAt: Date;
    ParsedResults: StudentAssessmentResults;
}

export class StudentAssessmentResults {
    JsonVersion: string;
    QuestionResults: StudentAssessmentQuestionResults[];
}

export class StudentAssessmentQuestionResults {
    EncounterID: string;
    TargetKey: string;
    SelectedKey: string;
    CompletedAt: Date;
}